import classNames from "classnames";
import CheckIcon from "@mui/icons-material/Check";

type PiQuizCheckboxProps = {
  checked: boolean;
  onChange: (e: boolean) => void;
  square?: boolean;
  size?: "default" | "small";
  variant?: "default" | "interaction-blue";
};

export default function PiBasicQuizCheckboxV2(props: PiQuizCheckboxProps) {
  const {
    checked,
    onChange,
    square,
    size = "default",
    variant = "default",
  } = { ...props };

  const onClick = () => onChange(!checked);

  return (
    <div
      className={classNames({
        "box-border flex cursor-pointer": true,
        "w-[36px] h-[36px]": size === "default",
        "w-[24px] h-[24px]": size === "small",
        "rounded-full": !square,
        "rounded-[5px]": square,
        "bg-interaction-correct hover:bg-interaction-correct-hover":
          checked && variant === "default",
        "bg-interaction-primary hover:bg-interaction-primary-hover":
          checked && variant === "interaction-blue",
        "border-solid border-[2px] border-interaction-primary hover:bg-interaction-primary-washed":
          !checked,
      })}
      onClick={onClick}
    >
      {checked && (
        <div className={"m-auto text-white"}>
          <CheckIcon />
        </div>
      )}
    </div>
  );
}
